import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { InteractionsService } from 'src/app/services/interactions.service';
import { MethodsService } from 'src/app/services/methods.service';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-quadrato-magico',
  templateUrl: './quadrato-magico.component.html',
  styleUrls: ['./quadrato-magico.component.scss']
})
export class QuadratoMagicoComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;
  private interaction;
  public backgroundImage;
  private interactionsSubscriber;


  public originalConfig;

  @ViewChild('player_container') playerContainer;

  pieces;
  config;
  hint = false;

  rows;
  cols;
  randomRowIndex;
  randomColIndex;
  randomRowValue;
  randomColValue;

  checkPairs = [];

  startingTableToCheck = [];
  startingArrayToCheck = [];

  completed = 0;
  solved = false;


  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService
  ) { }

  ngOnInit(): void {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' + this.interaction.content.configId + '.config.json')
      .subscribe( config => {
        this.originalConfig = config;
        config = this.mapData(config);
        this.config = config.config;
        this.pieces = config.pieces;
        this.backgroundImage = config.config.backgroundImage;
        this.startingTableToCheck = _.sortBy(this.pieces, ['actualPosition.top', 'actualPosition.left']);
        console.log('startingTableToCheck', this.startingTableToCheck);
        this.startingTableToCheck.forEach(piece => {
          if (piece.id !== 9) {
            this.startingArrayToCheck.push(piece.id);
          } else {
            this.startingArrayToCheck.push(0);
          }
        });
        this.countInversions(this.startingArrayToCheck);
      });
    });
  }

  mapData(config) {
    console.log('eccolo qui', config);
    if (config) {
      config = {
        config: config.config,
        pieces: config.pieces.map(pezzi => {
            this.rows = config.config.rows;
            this.cols = config.config.cols;
            this.config = config.config;
            return {
              id: pezzi.id,
              top: config.config.piecesWidth * pezzi.top,
              left: config.config.piecesWidth * pezzi.left,
              actualPosition: this.getStartingPosition(),
              inPosition: this.checkStartingPosition(pezzi.top, pezzi.left),
              playable: pezzi.playable
            };
          })
      };
    }
    return config;
  }

  movePiece(index) {
    const lastPieceIndex = this.pieces.length - 1;
    const clickedPiece = this.pieces[index];
    const voidPiece = this.pieces[lastPieceIndex];
    const clickedPieceTop = clickedPiece.actualPosition.top;
    const clickedPieceLeft = clickedPiece.actualPosition.left;

    if (clickedPiece.inPosition === true) {
      this.completed--;
    }

    if (index === lastPieceIndex || this.solved) {
      console.log('non cliccabile, è l\'ultimo');
      return;
    } else if (clickedPiece.actualPosition.top === voidPiece.actualPosition.top ||
      clickedPiece.actualPosition.top === voidPiece.actualPosition.top + 100 ||
      clickedPiece.actualPosition.top === voidPiece.actualPosition.top - 100) {

      if (clickedPiece.actualPosition.left === voidPiece.actualPosition.left ||
        clickedPiece.actualPosition.left === voidPiece.actualPosition.left + 100 ||
        clickedPiece.actualPosition.left === voidPiece.actualPosition.left - 100) {


        if (clickedPiece.actualPosition.left === voidPiece.actualPosition.left ||
          clickedPiece.actualPosition.top === voidPiece.actualPosition.top) {

          this.pieces[index].actualPosition.top = voidPiece.actualPosition.top;
          this.pieces[index].actualPosition.left = voidPiece.actualPosition.left;

          this.pieces[lastPieceIndex].actualPosition.top = clickedPieceTop;
          this.pieces[lastPieceIndex].actualPosition.left = clickedPieceLeft;

          if (this.pieces[index].actualPosition.top === this.pieces[index].top &&
            this.pieces[index].actualPosition.left === this.pieces[index].left

          ) {
            this.pieces[index].inPosition = true;
            this.completed++;
            if (this.completed === 8) {
              setTimeout(() => {
                this.solved = true;
              }, 1000);

            }
          } else {
            this.pieces[index].inPosition = false;
          }
        } else {
          console.log('non si può muovere');
          return;
        }

      } else {
        console.log('non si può muovere');
        return;
      }

    } else {
      console.log('non si può muovere');
      return;
    }
  }

  getStartingPosition() {

    this.pickLeft();
    this.pickTop();

    const toInsert = {col: this.randomColValue, row: this.randomRowValue};
    if (_.find(this.checkPairs, toInsert)) {
      /* console.log('ESISTE');*/
      return this.getStartingPosition();
    } else {
      /*console.log('non esiste');*/
      this.rows.splice(this.randomRowIndex, 1);
      this.cols.splice(this.randomColIndex, 1);
      this.checkPairs.push(toInsert);
      /*      console.log('checkPairs', this.checkPairs);*/

      return {top: this.randomRowValue * this.config.piecesWidth, left: +this.randomColValue * this.config.piecesWidth};
    }
  }

  pickLeft() {

    let randomIndex = Math.floor(Math.random() * this.rows.length);
    if (randomIndex === undefined) {
      randomIndex = 0;
    }
    this.randomColIndex = randomIndex;
    this.randomColValue = this.cols[randomIndex];
  }

  pickTop() {

    let randomIndex = Math.floor(Math.random() * this.cols.length);
    if (randomIndex === undefined) {
      randomIndex = 0;
    }
    this.randomRowIndex = randomIndex;
    this.randomRowValue = this.rows[randomIndex];

  }


  checkStartingPosition(top, left) {

    if (top === this.randomRowValue && left === this.randomColValue) {
      this.completed++;
      if (this.completed === 8) {
        setTimeout(() => {
          this.solved = true;
        }, 1000);
      }
      return true;
    } else {
      return false;
    }
  }


  solve() {
    this.pieces.forEach(piece => {
      this.completed = 8;
      piece.actualPosition.top = piece.top;
      piece.actualPosition.left = piece.left;
      this.hint = false;
    });
    setTimeout(() => {
      this.solved = true;
    }, 2000);
  }

  resetGame() {
    location.reload();
  }



  countInversions(arr) {
    let ctr = 0;
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] > arr[j]) {
          ctr++;
        }
      }
    }
    const zeroIndex = _.indexOf(this.startingArrayToCheck, 0);

    if ((ctr - zeroIndex) % 2 !== 0) {

      setTimeout(this.mapData(this.originalConfig), 2000);
    } else {

    }
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
